import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { WorkOrders_ModuleContextService } from './WorkOrders.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class WorkOrders_work_order_total_completed_units_by_date_widget_ComponentContextService {
  private readonly moduleContext: WorkOrders_ModuleContextService;

  constructor(moduleContext: WorkOrders_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'work_order_total_completed_units_by_date_widget',
      type: ComponentType.widget
    }
  }
}